import React from "react";
import { HiOutlineArrowRightOnRectangle } from "react-icons/hi2";
import ThemeToggle from "../../common/ThemeToggle";
import {
  surfaceMuted,
  borderSub,
  textPrimary,
  textSecondary,
  roundedPanel,
  roundedBtn,
} from "./designTokens";

export function SidebarFooter({ isCollapsed, user, handleLogout, t }) {
  return (
    <div className={`shrink-0 pt-2 border-t ${borderSub} space-y-2`}>
      <div className={isCollapsed ? "flex justify-center" : "px-2"}>
        <ThemeToggle />
      </div>
      {user && !isCollapsed && (
        <div className="px-2">
          <div
            className={`flex items-center gap-3 p-2 ${roundedPanel} ${surfaceMuted}`}
          >
            <div
              className={`w-9 h-9 ${roundedBtn} bg-gray-800 dark:bg-gray-600 text-white flex items-center justify-center text-sm font-semibold shrink-0`}
            >
              {user.first_name?.charAt(0).toUpperCase() ||
                user.username?.charAt(0).toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <p className={`text-sm font-medium truncate ${textPrimary}`}>
                {user.first_name || user.username}
              </p>
              <p className={`text-xs truncate ${textSecondary}`}>
                {user.email}
              </p>
            </div>
          </div>
        </div>
      )}
      <button
        onClick={handleLogout}
        className={`w-full flex items-center justify-center gap-2 py-2.5 ${roundedPanel} text-white hover:bg-white/20 dark:hover:bg-white/10 transition-colors ${isCollapsed ? "px-0" : "px-3"}`}
        title={t("logout")}
      >
        <HiOutlineArrowRightOnRectangle className="w-5 h-5 shrink-0" />
        {!isCollapsed && (
          <span className="text-sm font-medium text-white">
            {t("logout")}
          </span>
        )}
      </button>
    </div>
  );
}
